import { Stack } from "@mui/material";
import PageLayout from "../../_components/PageLayout";
import Header from "../../_modules/Header/Header";
import Market from "./components/Market";
import Spacer from "../../_components/Spacer";
import { markets } from "../../_app/consts";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const ChooseMarketsPage: FC = () => {
  const { t } = useTranslation("account");

  return (
    <PageLayout
      contentSx={{ padding: "20px 8px 0" }}
      header={<Header pageTitle={t("addAccount")} needBack />}
    >
      <Stack direction={"column"} gap={1} sx={{ width: "100%" }}>
        {markets.map((market) => (
          <Market market={market} />
        ))}
      </Stack>
      <Spacer height="10px" />
    </PageLayout>
  );
};

export default ChooseMarketsPage;
